export const setSoundkitReducer = (state, action) => ({
   ...state,
   soundKit: action.soundKit,
});
